export default {
  // 标签管理
  labelManagement: "标签管理",
};
